import { useEffect, useState } from "react";
import { countdownParts } from "@/lib/time";

export function Countdown({ target, compact = false }: { target: Date | string; compact?: boolean }) {
  const t = typeof target === "string" ? new Date(target) : target;
  const [, tick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => tick((x) => x + 1), 1000);
    return () => clearInterval(i);
  }, []);
  const { d, h, m, s, total } = countdownParts(t);
  const urgent = total > 0 && total < 2 * 3600 * 1000;
  const cls = `inline-flex items-center gap-1 font-display font-bold tabular-nums ${
    urgent ? "text-destructive pulse-urgent" : "text-foreground"
  } ${compact ? "text-sm" : "text-lg"}`;
  if (total <= 0) return <span className={cls}>00:00:00</span>;
  return (
    <span className={cls}>
      {d > 0 && <span>{d}T</span>}
      <span>{String(h).padStart(2, "0")}:{String(m).padStart(2, "0")}:{String(s).padStart(2, "0")}</span>
    </span>
  );
}
